import { ConfigLoaderService } from './config-loader-service.service';

export function PreloadFactory(configService: ConfigLoaderService) {
  return () => configService.initialize();
}
